import {Component} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-send-survey-filters',
  templateUrl: './send-survey-filters.component.html',
  styleUrls: ['./send-survey-filters.component.css']
})
export class SendSurveyFiltersComponent {
  form: FormGroup = new FormGroup<any>({
    active: new FormControl(''),
    inactive: new FormControl('')
  })

  constructor(private dialogRef: MatDialogRef<SendSurveyFiltersComponent>) {
  }

  closeButtonClickHandler() {
    this.dialogRef.close()
  }
}
